import cookies from 'js-cookie';

export const getFormFieldDefaultValue = (
  fieldName: string,
  query?: Record<string, string>
): string | undefined => {
  if (!query) {
    try {
      const url = new URL(window.location.href);
      const params: Record<string, string> = {};
      url.searchParams.forEach((value, key) => {
        params[key] = value;
      });
      query = params;
    } catch (e) {
      console.error('getDefaultValue failed: ', e);
      return undefined;
    }
  }
  query = {
    ...cookies.get(),
    ...query,
  };
  const queryName = Object.keys(query).find((key) => fieldName.toLowerCase() === key.toLowerCase());
  return queryName ? query[queryName] : undefined;
};
